"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "defaultShadows", {
    enumerable: true,
    get: function() {
        return defaultShadows;
    }
});
var defaultShadows = {
    "elevation-default": "0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px 0px rgba(0, 0, 0, 0.06)",
    "elevation-interactive": "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)",
    "elevation-modals": "0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)",
    "elevation-outline": "0px 0px 0px 3px rgba(194, 194, 255, 0.3)",
    "elevation-inner": "inset 0px 2px 4px 0px rgba(0, 0, 0, 0.06)"
};
